import React, { useContext } from 'react';
import NavbarContext from '../../context/navbar/navbarContext';

const Burger = () => {
    const navbarContext = useContext(NavbarContext);
    const { nav, toggleNav } = navbarContext;

    return (
        <div className={`burger ${nav && 'toggle'}`} onClick={toggleNav}>
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
        </div>
    )
}


export default Burger;
